// extracted by mini-css-extract-plugin
module.exports = {"emailImagePdfView":"InboxImage_emailImagePdfView_1DOAM"};